
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"15","width":"9","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.63 9.033c-3.066.214-5.508 2.78-5.65 5.967H.022c.095-3.136 1.686-5.882 4.06-7.5C1.708 5.882.117 3.136.022 0h2.957c.143 3.187 2.585 5.753 5.651 5.967z","fill":"currentColor"}})])
          )
        }
      }
    